import { Image } from "@components/anti/Image"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function LocationDetailMaps({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className="sc-location-detail-maps" ref={trigger}>
      <div className="py-main">
        <div className="container">
          <div className="row row-4">
            <div className="col-md-7 col-maps">
              {convertHtmlToReact(data?.maps?.embed_url)}
            </div>
            <div className="col-md-5 col-text">
              <h4 className={`title ${anim(2)}`}>
                {translations[`address_${locale}`]}
              </h4>
              <p className={`text ${anim(3, "fadeInUp7")}`}>
                {data?.excerpt_id} <br /> {data?.address} <br />{" "}
                {data?.city?.name}
              </p>
              <span className={`phone-wrapper ${anim(4)}`}>
                <Image
                  src="/img/icon/img_icon-phone.svg"
                  alt="ic-phone"
                  className="ic-phone"
                  width={24}
                  height={24}
                />
                <p className="phone">{data?.phone}</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LocationDetailMaps
